const CIMSTableCell: React.FC = ({ children }) => (
  <div
    onClick={(e) => e.stopPropagation()}
    style={{ cursor: 'auto', overflow: 'clip' }}
  >
    {children}
  </div>
)

export default CIMSTableCell
